export class FilterForm {
    constructor()
    {
        document.querySelectorAll('.ajax-filter-form').forEach(form => {
            const endpointEl = form.getAttribute('ajax-filter-form-endpoint');
            const endpoint = document.querySelector(endpointEl);

            form.addEventListener('change', evt => {
                evt.preventDefault()

                if (!endpoint.classList.contains('is-loading')) {
                    endpoint.classList.add('is-loading')
                    const loaderContainer = document.createElement('div')
                    loaderContainer.classList.add('loader-container')
                    
                    const loader = document.createElement('div')
                    loader.classList.add('loader')
                    loaderContainer.append(loader)

                    endpoint.append(loaderContainer)
                }

                const params = new URLSearchParams(new FormData(form));
                fetch(`?${params.toString()}`)
                    .then(r => r.text())
                    .then(html => {
                        const parser = new DOMParser();
                        const htmlDocument = parser.parseFromString(html, "text/html");

                        endpoint.classList.remove('is-loading')
                        const replace = htmlDocument.querySelector(endpointEl)
                        endpoint.innerHTML = replace.innerHTML
                    })
            })
        })
    }
}
